import {multiPopupWindowState} from '@/services/state/popupWindow';

import type {INotificationHandler} from '../types';

export const createOpenUrlHandler = (): INotificationHandler => {
  const canHandle = (action: string): boolean => {
    return action === 'open_url';
  };

  const handle = async (message: Record<string, unknown>): Promise<boolean> => {
    const params = message.params as Record<string, unknown> | undefined;
    const url = params?.url as string | undefined;
    if (!url) {
      console.error('Notification action: url missing', message);
      return false;
    }

    multiPopupWindowState.openDefault(url);
    return true;
  };

  return {canHandle, handle};
};
